import type { AccountCampaign } from '../../types/accountCampaign';
import type { Campaign } from '../../types/campaign';
import { getDriftedFields } from '../../lib/getDriftedFields';
import type { RefreshableFieldKey } from '../../lib/refreshableFields';

// Compare a row's snapshotted content against its Campaign's CURRENT values.
// Returns the set of field keys that differ — used by the row editor's
// per-field modification badges and (via hasRowModifications) the master /
// build grids' modification dot.
//
// ── Granular Refresh migration (spec §5 / §6.3) ─────────────────────────
// This used to carry its own deepEqual + per-field comparison. It now
// delegates to the canonical getDriftedFields / refreshableFields manifest
// so there is exactly ONE comparison implementation feeding both the bulk
// refresh modal and the badges. Behaviour is preserved key-for-key (proven
// by src/lib/getDriftedFields.test.ts's parity battery, which ran against
// the legacy implementation before this delegation) with ONE intended
// addition: `metaCreativeFolderName`. That field is snapshotted from the
// Campaign and refreshable, but the legacy diff never compared it, so its
// drift was silently invisible on the badges. It now surfaces correctly.
//
// RowContentFieldKey is kept as the public type name (many call sites use
// `diffSet.has('metaAdCopy.bodyCopy')` etc.) and is now exactly the
// manifest's key union — including the two comparison-only Overview URLs,
// which getDriftedFields still reports so badge behaviour for legacy rows
// is unchanged.

export type RowContentFieldKey = RefreshableFieldKey;

export function diffCampaignVsRow(
  row: AccountCampaign,
  campaign: Campaign,
): Set<RowContentFieldKey> {
  return new Set(getDriftedFields(row, campaign));
}
